import React from 'react';

import {
  Accent,
  TextBlockContainer,
  TextBlockText,
  TextBlockSection,
  TextBlockSectionTitle,
  TextBlocksContainer,
  TextBlockDek,
} from 'components/TextBlock/TextBlock.styles';

type TrendingQuestionsTextBlockProps = {
  className?: string;
};

export const faqItems = [
  {
    question: 'Are cash gifts tacky?',
    answer:
      'Team-Z: Absolutely not! We find that when couples create specific cash gifts, their guests treat it like a gift and love to give them that experience.',
  },
  {
    question: 'Do I need to invite my coworkers to my wedding?',
    answer:
      "Team-Z: If you want them to be there, and have it in your budget, awesome! But it's not expected unless you're really good friends with them.",
  },
  {
    question: "We're a week out — what are we forgetting?",
    answer: `Team-Z: Have you packed a day-of emergency kit? How about the final details of who is setting up any signage? Finalize tips and payments for vendors — prep those envelopes! Make sure you have the rings!`,
  },
];

const TrendingQuestionsTextBlock = ({
  className,
}: TrendingQuestionsTextBlockProps): JSX.Element => (
  <div className={className}>
    <TextBlockSection>
      <TextBlockSectionTitle>
        Trending <Accent>questions</Accent> from our couples
      </TextBlockSectionTitle>
      <TextBlockDek>We love all of your questions. Seriously! It&apos;s okay to ask…</TextBlockDek>
      <TextBlocksContainer>
        <TextBlockContainer>
          <TextBlockText>
            <strong>Q:</strong>
            <br />
            Are cash gifts tacky?
            <br />
            <br />
            <strong>Team-Z:</strong>
            <br />
            Absolutely not! We find that when couples create specific cash gifts, their guests treat
            it like a gift and love to give them that experience.
          </TextBlockText>
        </TextBlockContainer>
        <TextBlockContainer>
          <TextBlockText>
            <strong>Q:</strong>
            <br />
            Do I need to invite my coworkers to my wedding?
            <br />
            <br />
            <strong>Team-Z:</strong>
            <br />
            If you want them to be there, and have it in your budget, awesome! But it&apos;s not
            expected unless you&apos;re really good friends with them.
          </TextBlockText>
        </TextBlockContainer>
        <TextBlockContainer>
          <TextBlockText>
            <strong>Q:</strong>
            <br />
            We&apos;re a week out — what are we forgetting?
            <br />
            <br />
            <strong>Team-Z:</strong>
            <br />
            Have you packed a day-of emergency kit? How about the final details of who is setting up
            any signage? Finalize tips and payments for vendors — prep those envelopes! Make sure
            you have the rings!
          </TextBlockText>
        </TextBlockContainer>
      </TextBlocksContainer>
    </TextBlockSection>
  </div>
);

export default TrendingQuestionsTextBlock;
